@use '../../scss/utility';

:host {
  display: block;
  position: relative;
  background: var(--wb-list-group-background-color-default);
}

.image-desktop {
  display: none;
  position: absolute;
  background-size: cover;
  background-position: center center;
  inset-block: 0 0;
  inset-inline: 50% 0;
}

.grid-width {
  display: block;
  margin-block: 0;
  margin-inline: auto;
  width: var(--wb-grid-width);
  padding-block: var(--wb-spacing-l);
}

@include utility.breakpoint-from(mq4) {
  .image-desktop {
    display: block;
  }

  .image-mobile {
    display: none;
  }

  .content {
    width: calc(50% - var(--wb-spacing-l));
    box-sizing: border-box;

    &.no-image {
      width: calc(8 * var(--wb-grid-column-width) + 7 * var(--wb-grid-gutter-width));
    }
  }
}

.footer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--wb-spacing-xxs);
  margin-block-start: var(--wb-spacing-s);
}

::slotted(.wb-heading) {
  margin-block-end: var(--wb-spacing-xs);
  color: var(--wb-text-headline-text-headline-color);
}

::slotted(.wb-text) {
  color: var(--wb-load-more-progress-text-color);
}

::slotted(.wb-button[slot='footer']) {
  @include utility.breakpoint-to('mq2') {
    flex-basis: 100%;
  }
}
